import { render, staticRenderFns } from "./TgCardGroup.vue?vue&type=template&id=1da407ad&"
import script from "./TgCardGroup.vue?vue&type=script&lang=js&"
export * from "./TgCardGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports